module.exports = __webpack_public_path__ + "static/media/diktat-12.5cb9086a.mp3";